import React from 'react';
import { useNavigate } from 'react-router-dom';

export const BrandLogo = ({ className = '' }) => {
  const navigate = useNavigate();
  return (
    <div className={`h-14 px-4 flex items-end pb-3 border-b ${className}`} style={{ borderColor: 'rgba(56, 189, 248, 0.08)' }} data-testid="brand-logo">
      <button
        type="button"
        onClick={() => navigate('/')}
        className="flex items-end gap-2.5 hover:opacity-100 transition-opacity focus:outline-none focus:ring-1 focus:ring-white/20 rounded-md"
        title="Back to home"
        data-testid="brand-logo-home-btn"
      >
        <img src="/assets/eipi-logo.png" alt="Eipicenter — back to home" className="h-5 w-auto brightness-0 invert opacity-80 hover:opacity-100 transition-opacity" />
        <span className="text-[11px] font-semibold uppercase tracking-[0.2em] leading-none text-slate-300/80 hover:text-slate-100 -mb-[1px] transition-colors">Eipicenter</span>
      </button>
    </div>
  );
};
